module.exports = __webpack_public_path__ + "static/media/icon-zip.52a8a289.svg";